<template>
  <div class="interest" ref="interest">
    <template v-if="!scoreEnd.defaults">
      <div class="relative overflow-hidden" ref="poster" @click="onPreview">
        <div class="poster-wrapper" ref="image">
          <img :src="bgImage.url" alt="" @load="onBgLoad" />
        </div>
        <div class="poster-content" v-if="bgLoad">
          <div class="poster-info" ref="info">
            <div v-if="scoreEnd.displayPicture && user" class="flex">
              <div class="user-avatar">
                <van-image
                  round
                  :width="40 * scale + 'px'"
                  :height="40 * scale + 'px'"
                  :src="user.weixinHeadimgurl"
                  @load="onAvatarLoad"
                />
              </div>
              <div class="ml-3 mb-1">
                <div ref="nickName" class="text-theme-black-850">
                  <span>{{ user.weixinNickName }}</span>
                </div>
                <div v-html="scoreEnd.richText" ref="welcome"></div>
              </div>
            </div>
          </div>
          <div class="poster-text-content" ref="textContent" v-if="scoreEnd.posterContent" v-html="scoreEnd.posterContent"></div>
          <div class="poster-user-list" ref="userList" v-if="scoreEnd.users && scoreEnd.users.length">
            <div v-for="(u,i) in scoreEnd.users" :key="i" class="poster-user-item">
              <div>
                <van-image
                  round
                  :width="40 * scale + 'px'"
                  :height="40 * scale + 'px'"
                  :src="u.weixinHeadimgurl"
                />
                {{u.weixinNickName}}
              </div>
              <div>
                {{u.answerContent}}
              </div>
            </div>
          </div>
          <div class="poster-qrcode" ref="qrcode">
            <vue-qr :callback="onQrcodeLoad" :logo-src="logoSrc" :text="url" :margin="10" :size="600" :logo-scale="0.15"></vue-qr>
          </div>
        </div>
        <div class="poster-wrapper poster-mask" v-if="posterUrl">
          <img alt="" :src="posterUrl" />
        </div>
      </div>
      <van-button type="primary" size="small" block v-if="genPosterUrlError" @click="onGenPoster"> 重新生成海报</van-button>
      <van-button type="primary" size="small" block v-else> 长按图片分享给好友</van-button>
    </template>
    <template v-else>
      <div v-html="scoreEnd.richText"></div>
    </template>
  </div>
</template>

<script>
import { addErrorLog, getFileStream, getUserById, logoSrc } from 'dygc'
import VueQr from 'vue-qr'
import html2canvas from 'html2canvas'
import { ImagePreview } from 'vant'

export default {
  name: 'Interest',
  components: { VueQr },
  data() {
    return {
      bgImage: {},
      scale: 1,
      logoSrc,
      url: '',
      bgLoad: false,
      posterUrl: '',
      genPosterUrlError: false
    }
  },
  computed: {
    user() {
      return this.$bus.user
    },
    scoreEnd() {
      return this.$bus.scoreEnd
    }
  },
  methods: {
    init() {
      const scoreEnd = this.$bus.scoreEnd
      if (scoreEnd.defaults) {
        return
      }
      if (!scoreEnd.image || !scoreEnd.image.length) {
        return
      }
      this.bgImage = Object.assign({}, scoreEnd.image[0])
      this.bgImage.url = getFileStream(this.bgImage.url, 'haibao.jpeg')
      this.url = this.$answerUtil.getShareUrl()
    },
    initStyle() {
      const scoreEnd = this.$bus.scoreEnd
      if (scoreEnd.defaults) return
      let clientWidth = this.$refs.image.clientWidth
      let realWidth = this.bgImage.horizontal || 270
      this.scale = clientWidth / realWidth
      if (scoreEnd.displayPicture) {
        this.setStyle(this.$refs.info, scoreEnd.info)
        const isScale = this.$bus.survey.otherSetting.enabledChatGPT
        if(isScale) {
          this.$refs.info.style.transform = 'scale(0.7)'
          this.$refs.info.style.transformOrigin = 'top left'
        }
      }
      if(scoreEnd.posterContent) {
        this.setStyle(this.$refs.textContent,scoreEnd.posterContentInfo)
      }

      if(this.initUserStoryStyle){
        this.initUserStoryStyle()
      }
      this.setStyle(this.$refs.qrcode, scoreEnd.qrcode)
      let match = this.scoreEnd.richText.match(/color:([^;]+);/)
      if (match && match[1]) {
        this.$refs.nickName.style.color = match[1]
        this.$refs.userList.style.color =  match[1]
      }
    },
    setStyle(el, info) {
      if (!el) return
      const scale = this.scale
      el.style.top = info.y * scale + 'px'
      el.style.left = info.x * scale + 'px'
      if (info.horizontal) {
        el.style.width = info.horizontal * scale + 'px'
      }
      if (info.vertical) {
        el.style.height = info.vertical * scale + 'px'
      }
    },
    onPreview() {
      ImagePreview({
        images: [this.posterUrl],
        closeable: true,
        showIndex: false
      })
    },
    onGenPoster() {
      if (this.$bus.scoreEnd.defaults) return
      this.$bus.closeLoading()
      this.$bus.openLoading("正在生成海报...")
      html2canvas(this.$refs.poster, {
        dpi: 120,
        useCORS: true,
        allowTaint: true
      })
        .then(canvas => {
          this.$bus.closeLoading()
          console.log(canvas)
          let s = canvas.toDataURL('image/png')
          this.genPosterUrlError = false
          this.posterUrl = s
        })
        .catch(err => {
          this.$bus.closeLoading()
          this.genPosterUrlError = true
          this.addErrorLog(err)
        })
    },
    addErrorLog(err) {
      addErrorLog({
        surveyId: this.$bus.survey.id,
        answerId: this.$bus.answerId,
        accountUserFingerprint: this.$bus.accountUserFingerprint,
        accountUserId: this.$bus.params.accountUserId,
        answerUrl: window.location.href,
        errTitle: '生成海报失败',
        errInfo: JSON.stringify(err)
      })
    },
    onAvatarLoad() {
      this.avatarLoad = true
      this.onGen()
    },
    onQrcodeLoad() {
      this.qrcodeLoad = true
      this.onGen()
    },
    onGen() {
      if (!this.scoreEnd.displayPicture || !this.user || !this.user.weixinHeadimgurl) {
        this.avatarLoad = true
      }
      if (this.qrcodeLoad && this.avatarLoad) {
        this.$nextTick(() => {
          this.onGenPoster()
        })
      }
    },
    onBgLoad() {
      this.bgLoad = true
      this.$nextTick(() => {
        this.initStyle()
      })
    }
  },
  created() {
    this.init()
  },
  mounted() {
    if (!this.scoreEnd.defaults) {
      this.$bus.openLoading()
    }
  }
}
</script>

<style scoped lang="scss">
.interest {
  position: relative;

  .poster-wrapper {
    img {
      display: block;
    }
  }

  .poster-mask {
    position: absolute;
    @apply inset-0 z-20;
  }

  .poster-content {
    position: absolute;
    @apply inset-0 z-10;
  }

  .poster-text-content {
    color: #AF6D33;
  }

  .poster-info,
  .poster-qrcode,
  .poster-user-list,
  .poster-text-content{
    position: absolute;
  }

  .poster-user-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
